const errorMessage = (error) => {
  try {
    return error.response.data.message || error.message
  } catch {
    return ''
  }
}

export const uiHelper = {
  errorMessage
}
